import { render, staticRenderFns } from "./bubble.vue?vue&type=template&id=3a548a08&scoped=true&"
import script from "./bubble.vue?vue&type=script&lang=js&"
export * from "./bubble.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a548a08",
  null
  
)

export default component.exports